import httpClient from './httpClient';

const AuthService = () => {
  return {
    login: async (token: string) => {
      return httpClient.setAuthToken(token);
    },
  };
};

export default AuthService();
